<template>
  <el-dialog
    class="dialog"
    title="资源配置"
    width="60%"
    :visible.sync="showSelect.flag"
    @close="cancelSelcet"
  >
    <div>
      <!--操作栏-->
      <div class="search_right search_content">
        <el-input
          prefix-icon="el-icon-search"
          v-model="query"
          placeholder="资源名称"
          class="name"
        ></el-input>

        <butn class="mlButn" btntype="primary" title="查询" @click="search"></butn>
        <butn class="czButn" title="重置" @click="resetData" ></butn>

      </div>
      
      <!--表格内容栏-->
      <el-table
          ref="pageListTable"
          border
          :data="resourseData"
          :row-key="getRowKeys"
          :row-style="{ color: '#51627D', fontWeight: 400,}"
          :header-cell-style="{
            background: '#DCE7FA',
            color: '#343C4A',
            fontWeight: 500,
          }"
          @selection-change="handleSelectionChanges"
        >
          <el-table-column
            type="selection"
            :selectable="selectInit"
            :reserve-selection="true"
            width="40"
          >
          </el-table-column>
          <el-table-column
            prop="audioName"
            label="资源名称"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="ellipsis--l2">{{scope.row.audioName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="onlineDate"
            label="上线时间"
            width="180"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      <!--分页栏-->
        <el-pagination
          class="pagination"
          @size-change="sizeChange"
          @current-change="pageChange"
          :current-page="page"
          :page-size="size"
          :page-sizes="[10, 50, 100, 500, 1000]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
          hide-on-single-page
        />
      </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelSelcet" size="small">取消</el-button>
      <el-button type="primary" size="small" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { getNoRAudio } from "@/api/audioSet";

export default {
  components: { butn },
  props: {
    showSelect: {
      type: Object,
      default: () => {
        return {
          flag: false,
          selectedList: [],
        };
      },
    },
    uuid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      getRowKeys(row) {
        return row.uuid;
      },
      query: "",
      page: 1,
      size: 10,
      total: 0,
      resourseData: [],
      selectedResourses: [],
      hasResourses: [],
    };
  },
  
  created() {
    if (this.showSelect.selectedList && this.showSelect.selectedList.length) {
      this.hasResourses = this.showSelect.selectedList.map(v => v.uuid);
    }
    this.getList();
  },
  methods: {
    /****** Search */
    search() {
      this.page = 1;
      this.getList();
    },
    resetData() {
      this.page = 1;
      this.query = '';
      this.getList();
    },
    
    getList() {
      getNoRAudio({
        page: this.page,
        limit: this.size,
        audioName: this.query,
        uuid: this.uuid,
      }).then((data) => {
        this.total = data.data.total;
        this.resourseData = data.data.records || [];
        this.resourseData.map((v) => {
          this.hasResourses.map((i) => {
            if (v.uuid == i) {
              v.disabled = true;
              this.$refs.pageListTable.toggleRowSelection(v);
            }
          });
        });

      });
    },
    
    cancelSelcet() {
      this.$emit("close", false);
    },

    confirm() {
      let realSelectData = this.selectedResourses.filter(v => !this.hasResourses.includes(v.uuid))
      if (!realSelectData.length) {
        this.$message({
          message: "请选择至少一条资源",
          type: "warning",
        });
      } else {
        this.$emit("confirm", [...this.showSelect.selectedList, ...realSelectData]);
      }
    },

    /******TABLE */
    pageChange(page) {
      this.page = page
      this.getList();
    },
    sizeChange(size) {
      this.size = size;
      this.getList();
    },
    selectInit(row) {
      return !row.disabled;
    },
    handleSelectionChanges(val) {
      this.selectedResourses = val;
    },

  },
};
</script>

<style lang="scss" scoped>
$text-color: #51627d;
$text-font: 14px;

/deep/ .el-pagination {
  text-align: right !important;
}

.dialog {
  /deep/ .el-dialog__body {
    max-height: auto;
    padding: 20px;
    .search_content {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }
    .mlButn{
      margin-left: 10px;
    }

  }
  .pagination {
    margin-top: 14px;
  }
}
</style>
